module.exports = __webpack_public_path__ + "static/media/Nicki Pierski.627cf760.png";